import React from "react";
import "bootstrap/dist/css/bootstrap-grid.css";
import "./styles/app.css";
import AppInner from "./AppInner";

const App = (): JSX.Element => (<AppInner />);

export default App;
